<template>
  <sliderBarDialogShell
    ref="sliderbar"
    :dialog-show="dialogShow"
    :dialog-title="title"
    @close="beforeClose"
    @submit="confirm"
    :click-not-close="true"
    class="add-config-dialog"
  >
    <div class="form-content">
      <config-form
        ref="outform"
        @submit="submit"
      ></config-form>
    </div>
  </sliderBarDialogShell>
</template>

<script>
import configForm from "@/components/sys/config/configForm";
import {addConfig} from "@/api/sys/config/config";

export default {
  name: "addConfigDialog",
  components: {
    configForm,
  },
  props: {
    dialogShow: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      title: '新增'
    }
  },
  methods: {
    beforeClose() {
      this.$emit('close');
      this.$refs.outform.selfClear();
    },
    cancel() {
      this.beforeClose();
    },
    confirm() {
      // todo
      this.$refs.outform.selfValidate();
    },
    submit(form) {
      let params = {
        'paramKey': form.paramKey,
        'paramValue': form.paramValue,
        'remark': form.remark
      }
      addConfig(params).then((data) => {
        if(data&&data.code&&data.code == 200){
          this.$message({
            message: '添加成功',
            type: 'success',
          });
          this.$refs.outform.selfClear();
          this.$emit('add-success');
        }else{
          this.$message.error(data.msg);
        }
      }).catch((err) => {
        // this.$message.error(err.msg);
      })
    }
  },
}
</script>

<style>
@media screen and (min-width: 768px) {
  .add-config-dialog.sidebar-dialog .vs-sidebar {
    width: 800px;
  }
}
</style>
